// extracted by mini-css-extract-plugin
export default {"filterItemContainer":"SearchDropdown_filterItemContainer__B185H","filterType":"SearchDropdown_filterType__ALqwx","closeIcon":"SearchDropdown_closeIcon__6bD2K"};